import React from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import {
  compose,
  setDisplayName,
} from 'recompose';
import MaterialAvatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';

import { getInitials } from 'helpers/utils';

const styles = theme => ({
  avatar: {
    pointerEvents: 'none',
  },
  highlighted: {
    border: '2px solid #45A7FF',
  },
  clickable: {
    pointerEvents: 'all',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
});

const Avatar = ({
  children,
  highlighted,
  clickable,
  classes,
  size,
  style,
  type,
  fullName,
  ...rest
}) => (
  <MaterialAvatar
    className={
      compact([
        classes.avatar,
        highlighted && classes.highlighted,
        clickable && classes.clickable,
      ]).join(' ')
    }
    style={{
      width: size,
      height: size,
      backgroundColor: {
        SO: 'white',
        SD: '#9fa1a3',
        PD: '#ffc107',
        PO: '#ff9800',
      }[type],
      color: {
        SO: 'grey',
        SD: 'white',
        PD: 'white',
        PO: 'white',
      }[type],
      ...style,
    }}
    {...rest}
  >
    {getInitials(fullName)}
    {children}
  </MaterialAvatar>
);

Avatar.propTypes = {
  children: PropTypes.node,
  clickable: PropTypes.bool,
  size: PropTypes.number,
  style: PropTypes.shape({}),
  type: PropTypes.string,
  highlighted: PropTypes.bool,
  classes: PropTypes.shape({}).isRequired,
  fullName: PropTypes.string,
};

Avatar.defaultProps = {
  children: null,
  clickable: false,
  highlighted: false,
  fullName: '',
  size: 50,
  style: {},
  type: 'SD',
};

export default compose(
  setDisplayName('Avatar'),
  withStyles(styles),
)(Avatar);
